export default __webpack_public_path__ + "static/media/easyThree.5700007d.png";